export type FilterModelRecord = Record<string, unknown>;

export const toFilterModelRecord = (filterModel: unknown): FilterModelRecord =>
	(filterModel as FilterModelRecord | null) ?? {};

const withSiteLocationScope = (filterModel: unknown, siteLocationId: string | null | undefined): unknown => {
	const trimmed = siteLocationId?.trim();
	if (!trimmed) return filterModel ?? null;
	return {
		...toFilterModelRecord(filterModel),
		siteLocationId: { filter: trimmed, filterType: "text", type: "equals" }
	};
};

export default withSiteLocationScope;
